import * as React from "react"
import Icon from "./Icon"
import { classNames } from "./utils"
import Link from "./Link"

const caret = (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.5004 8H26.1566C25.9973 8 25.8473 8.07813 25.7535 8.20625L16.8754 20.4438L7.99727 8.20625C7.90352 8.07813 7.75352 8 7.59415 8H5.2504C5.04727 8 4.92852 8.23125 5.04727 8.39688L16.066 23.5875C16.466 24.1375 17.2848 24.1375 17.6816 23.5875L28.7004 8.39688C28.8223 8.23125 28.7035 8 28.5004 8Z"
      fill="#E68659"
    />
  </svg>
)

const UniqueSellingPoints = ({ title, items, cta, className }) => {
  return (
    <div className={classNames("unique-selling-points", className)}>
      <h3>{title}</h3>
      <div>
        <div className="items">
          {items.map((usp, i) => (
            <div key={usp.title} className="item">
              <div>
                <Icon icon={usp.icon} />
                <h5>{usp.title}</h5>
              </div>
              {!cta && (
                <div key={i} className="usp-arrow">
                  <button
                    onClick={() =>
                      document
                        .querySelector(`#solution-highlight-${i}`)
                        .scrollIntoView({
                          behavior: "smooth",
                        })
                    }
                    className="button button-primary"
                  >
                    {caret}
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="usp-bottom">
          {cta ? (
            <Link to={cta.url} className="button button-primary">
              {cta.title}
            </Link>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default UniqueSellingPoints
